<template>
  <div
    :class="[wrapperClass, { 'has-error has-danger': validator && validator.$error && !wrapped }]">
    <div
      v-if="wrapped"
      :id="'select-wrapper-' + id"
      :class="[{ 'has-error has-danger': validator && validator.$error || errors }, selectWrapperClass]"
    />
    <slot name="icon"/>
    <div
      :class="['container__form rail-select', { 'validateInput': validator ? !validator.$error : field }]"
    >
      <select
        :id="id"
        v-model="field"
        :size="[size]"
        :class="[selectClass]"
        :disabled="disabled"
        class="container__input selectStyle"
        @change="!validator || validator.$touch()">
        <option
          v-if="withDefault"
          v-once
          :value="null"
        />
        <option
          v-for="(option, index) in options"
          :key="option[optionLabel] + index"
          :value="optionValue ? option[optionValue] : option"
        >
          {{ option[optionLabel] }}
        </option>
      </select>
      <label
        v-if="label"
        :for="id"
        :class="[labelClass]"
        class="container__label"> {{ label }}<span v-if="validator && validator.$params.required">*</span> </label>
    </div>

    <div
      :id="'list-box' + id"
      class="help-block form-text form-control-feedback"
    >
      <template v-for="(error, index) in errors">
        <strong :key="index"> {{ error }} </strong>
      </template>
      <strong
        v-if="validator && validator.$params.minLength && validator.$error && validator.minLength"
      >min length should not be less then {{ validator.$params.minLength.min }} characters!</strong>
    </div>
  </div>
</template>

<script>

export default {
	name: 't-list-box',
	props: {
		size: {
			type: Number,
			default: 5
		},
		label: {
			type: String,
			default: ''
		},
		labelClass: {
			type: String,
			default: 'col-form-label col-sm-4'
		},
		selectClass: {
			type: String,
			default: 'form-control'
		},
		wrapperClass: {
			type: String,
			default: 'form-row'
		},
		selectWrapperClass: {
			type: String,
			default: 'col-sm-8'
		},
		options: {
			type: Array,
			default: () => {
				return []
			}
		},
		optionLabel: {
			type: String,
			default: null
		},
		optionValue: {
			type: String,
			default: ''
		},
		withDefault: {
			type: Boolean,
			default: false
		},
		defaultText: {
			type: String,
			default: ''
		},
		value: {
			type: [Number, String, Array, Object, Boolean],
			default: 0
		},
		multiple: {
			type: Boolean,
			default: false
		},
		simple: {
			type: Boolean,
			default: false
		},
		wrapped: {
			type: Boolean,
			default: false
		},
		filter: {
			type: Boolean,
			default: false
		},
		validator: {
			type: Object,
			default: null
		},
		remote: {
			type: String,
			default: null
		},
		templateResult: {
			type: Function,
			default: null
		},
		templateSelection: {
			type: Function,
			default: null
		},
		processResults: {
			type: Function,
			default: null
		},
		processParams: {
			type: Function,
			default: null
		},
		disabled: {
			type: Boolean,
			default: false
		},
		errors: {
			type: Array,
			default: () => {
				return null
			}
		}
	},
	data () {
		return {
			remoteOptions: [],
			remoteOptionsLabel: ''
		}
	},
	computed: {
		field: {
			get () {
				return this.value
			},
			set (value) {
				this.$emit('change', value)
				this.$emit('input', value)
			}
		},
		id () {
			return Math.random().toString().replace('0.', '')
		}
	},
	watch: {
		options: {
			handler () {
				if (this.multiple && !this.simple) this.initMultipleSelect()
			},
			deep: true
		},
		disabled (newVal) {
			let select = document.getElementById(this.id)
			jQuery(select).prop('disabled', newVal)
		}
	},
	mounted () {
		if (this.wrapped) {
			let wrapper = document.getElementById(`select-wrapper-${this.id}`)
			let select = document.getElementById(this.id)
			let helpBlock = document.getElementById(`select-help-block-${this.id}`)
			wrapper.appendChild(select)
			wrapper.appendChild(helpBlock)
		}
		if (this.options && this.multiple && !this.remote && !this.simple) this.initMultipleSelect()
		if (this.remote) this.initRemoteSelect()
	},
	destroyed: function () {
		if (this.multiple && !this.simple) {
			let select = document.getElementById(this.id)
			select.setAttribute('multiple', 'multiple')
		}
	},
	methods: {
		initMultipleSelect () {
			let select = document.getElementById(this.id)
			select.setAttribute('multiple', 'multiple')
		},
		reset () {
			if (this.options && this.multiple && !this.remote && !this.simple) {
				let select = document.getElementById(this.id)
				jQuery(select).val([]).trigger('change')
				return
			}
			this.field = null
		}
	}
}
</script>
<style scoped>
.container__input {
  font-weight: normal;
}
.container__input + label {
  top: -8px!important;
  left: 16px;
  height: 10%;
  padding: .80em 1em!important;
  color: #047bf8;
	background: #ffffff;
	border: 1px solid #ddd !important;
	border-radius: 5px;
}
.has-danger .container__form.validateInput label {
  top: -8px!important;
  left: 16px;
  height: 10%;
  padding: .20em 1.5em;
  color: red;
}
.container__label {
	position: absolute;
	top: 9px!important;
	left: 4px;
	height: 10%;
	padding: .80em 1em!important;
	background-color:transparent;
	display: flex;
	align-items: center;
	color: #80868b;
	font-size: .70rem;
	width: auto;
}
.container__form{
	position: relative;
}
.rail-select .select-side {
  width: 22px;
    position: absolute;
    top: 1px;
    background-color: #fff;
    height: calc(100% - 2px);
    right: 1px;
    border-radius: 0px 3px 3px 0px;
    border-right: solid 1px #fff;
    border-top: solid 1px #fff;
    border-bottom: solid 1px #fff;
    pointer-events: none;
    text-align: center;
}
.rail-select .select-side:before {
  border-left: solid 1px fff;
  content: "";
  position: absolute;
  left: 0;
  bottom: 0;
  height: 100%;
  width: 1px;
}
.rail-select .select-side i {
  top: 4px;
    position: relative;
		color: #1415179c;
    font-weight: bold;
		}
.rail-select .select-side i.blue {
  color: #4e7af0;
}

.container__input.selectStyle {
    padding-top: 7px;
	padding-left: 4px;
	padding-right: 0;
    padding-bottom: 0;
	height: auto !important;
}

</style>



// WEBPACK FOOTER //
// src/components/common/listbox/index.vue